import React from 'react'
import {
    Form,
    Input,
    Icon,
    Button,
    Row,
    Col,
    InputNumber,
    Select,
    Divider,
    Card,
    Tag,
    Typography,
    Empty,
} from 'antd'
import ProductAutocomplete from './ProductAutocomplete'

const { Option } = Select;
const { Title, Text, Paragraph } = Typography;

const DISCOUNT_KIND_STYLES = {
    percentage: { color: '#1890ff', icon: 'percentage', label: 'Porcentaje' },
    range: { color: '#722ed1', icon: 'bars', label: 'Rango por cantidad' },
}

class DiscountForm extends React.Component {
    constructor(props) {
        super(props);
        const initialCustomDiscounts = props.customDiscounts || []
        this.customDiscountKeyCounter = initialCustomDiscounts.reduce(
            (max, custom) => Math.max(max, custom.key || 0),
            0,
        )
        // eslint-disable-next-line react/state-in-constructor
        this.state = {
            simplePercentage: props.simplePercentage,
            customDiscounts: initialCustomDiscounts,
        }
    }

    componentDidMount() {
        if (this.props.item_based_discount) {
            // eslint-disable-next-line prefer-const
            let refreshForm = {}
            if (this.props.item_based_discount.discount_type) {
                refreshForm.discount_type = this.props.item_based_discount.discount_type;
            }
            if (this.props.item_based_discount.discount_value) {
                refreshForm.discount_value = this.props.item_based_discount.discount_value;
            }
            if (this.props.form && Object.keys(refreshForm).length !== 0) {
                // eslint-disable-next-line react/no-did-update-set-state
                this.props.form.setFieldsValue({ ...refreshForm });
            }
        }
    }

    handleSubmit = (e) => {
        e.preventDefault()
        if (this.props.onCompleted) {
            this.props.onCompleted();
        }
    }

    // Guarda el cambio en el estado local y lo sube de inmediato al contenedor padre,
    // para que sobreviva si el usuario regresa a un paso anterior y vuelve (el paso 3
    // se desmonta al cambiar de "current" en el wizard).
    updateAndNotify = (partialState) => {
        this.setState(partialState, () => {
            if (this.props.onDiscountsChange) {
                this.props.onDiscountsChange({
                    simplePercentage: this.state.simplePercentage,
                    customDiscounts: this.state.customDiscounts,
                })
            }
        })
    }

    toComplete = () => {
        // eslint-disable-next-line no-unused-vars
        this.props.form.validateFields((err, values) => {
            if (!err) {
                this.props.onCompleted();
            }
        })
    }

    addCustomDiscount = () => {
        this.customDiscountKeyCounter += 1
        // eslint-disable-next-line prefer-const
        let { customDiscounts } = this.state
        customDiscounts = [...customDiscounts, {
            key: this.customDiscountKeyCounter,
            selectedProducts: [],
            discountKind: undefined,
            percentageValue: undefined,
            rangeMin: undefined,
            rangeMax: undefined,
            rangeDiscountType: 'percentage',
            rangeValue: undefined,
        }]
        this.updateAndNotify({ customDiscounts })
    }

    removeCustomDiscount = (index) => {
        // eslint-disable-next-line prefer-const
        let { customDiscounts } = this.state
        customDiscounts = customDiscounts.filter((_, i) => i !== index)
        this.updateAndNotify({ customDiscounts })
    }

    updateCustomDiscount = (index, field, value) => {
        // eslint-disable-next-line prefer-const
        let { customDiscounts } = this.state
        customDiscounts = customDiscounts.map((custom, i) => (
            i === index ? { ...custom, [field]: value } : custom
        ))
        this.updateAndNotify({ customDiscounts })
    }

    renderCustomDiscount = (custom, index) => {
        const kindStyle = DISCOUNT_KIND_STYLES[custom.discountKind] || { color: '#bfbfbf', icon: 'tag' }

        return (
            <Card
                key={custom.key}
                size="small"
                style={{
                    textAlign: 'left',
                    borderRadius: '8px',
                    marginTop: '16px',
                    borderLeft: `4px solid ${kindStyle.color}`,
                    boxShadow: '0 1px 4px rgba(0, 0, 0, 0.08)',
                }}
                bodyStyle={{ padding: '20px' }}
            >
                <div
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        marginBottom: '16px',
                    }}
                >
                    <Title level={4} style={{ margin: 0, color: kindStyle.color }}>
                        <Icon type={kindStyle.icon} style={{ marginRight: 8 }} />
                        {`Descuento personalizado #${index + 1}`}
                    </Title>
                    <Button
                        type="danger"
                        icon="delete"
                        disabled={this.props.isLoading}
                        onClick={() => this.removeCustomDiscount(index)}
                    >
                        Eliminar
                    </Button>
                </div>

                <Form.Item label="Buscar y seleccionar productos">
                    <ProductAutocomplete
                        disabled={this.props.isLoading}
                        selected={custom.selectedProducts}
                        onChange={(selectedProducts) => this.updateCustomDiscount(index, 'selectedProducts', selectedProducts)}
                        applyTo={this.props.apply_to}
                        itemsToApply={this.props.items_to_apply}
                        excludedProductIds={this.state.customDiscounts
                            .filter((_, otherIndex) => otherIndex !== index)
                            .flatMap((otherCustom) => otherCustom.selectedProducts.map((product) => product.id))}
                    />
                </Form.Item>

                {custom.selectedProducts.length > 0 && (
                    <div style={{ marginBottom: '20px' }}>
                        <Text strong style={{ display: 'block', marginBottom: '8px' }}>
                            {`Productos seleccionados (${custom.selectedProducts.length})`}
                        </Text>
                        <div>
                            {custom.selectedProducts.map((product) => (
                                <Tag
                                    key={product.id}
                                    color="blue"
                                    closable={!this.props.isLoading}
                                    style={{ marginBottom: '6px' }}
                                    onClose={(e) => {
                                        e.preventDefault()
                                        this.updateCustomDiscount(
                                            index,
                                            'selectedProducts',
                                            custom.selectedProducts.filter((p) => p.id !== product.id),
                                        )
                                    }}
                                >
                                    {product.name}
                                </Tag>
                            ))}
                        </div>
                    </div>
                )}

                <Form.Item label="Tipo de descuento">
                    <Select
                        disabled={this.props.isLoading}
                        placeholder="Selecciona porcentaje o rango"
                        style={{ width: '220px' }}
                        value={custom.discountKind}
                        onChange={(value) => this.updateCustomDiscount(index, 'discountKind', value)}
                    >
                        <Option value="percentage">
                            <Icon type="percentage" style={{ marginRight: 6, color: DISCOUNT_KIND_STYLES.percentage.color }} />
                            Porcentaje
                        </Option>
                        <Option value="range">
                            <Icon type="bars" style={{ marginRight: 6, color: DISCOUNT_KIND_STYLES.range.color }} />
                            Rango por cantidad
                        </Option>
                    </Select>
                </Form.Item>

                {custom.discountKind === 'percentage' && (
                    <Form.Item label="Porcentaje de descuento" style={{ marginBottom: 0 }}>
                        <InputNumber
                            disabled={this.props.isLoading}
                            min={0}
                            max={100}
                            placeholder="Porcentaje"
                            formatter={(value) => (value === undefined || value === '' ? '' : `${value}%`)}
                            parser={(value) => value.replace('%', '')}
                            style={{ width: '200px' }}
                            value={custom.percentageValue}
                            onChange={(value) => this.updateCustomDiscount(index, 'percentageValue', value)}
                        />
                    </Form.Item>
                )}

                {custom.discountKind === 'range' && (
                    <Row gutter={12}>
                        <Col xs={12} sm={6}>
                            <Form.Item label="Mínimo">
                                <InputNumber
                                    disabled={this.props.isLoading}
                                    min={1}
                                    style={{ width: '100%' }}
                                    value={custom.rangeMin}
                                    onChange={(value) => this.updateCustomDiscount(index, 'rangeMin', value)}
                                />
                            </Form.Item>
                        </Col>
                        <Col xs={12} sm={6}>
                            <Form.Item label="Máximo">
                                <InputNumber
                                    disabled={this.props.isLoading}
                                    min={1}
                                    style={{ width: '100%' }}
                                    value={custom.rangeMax}
                                    onChange={(value) => this.updateCustomDiscount(index, 'rangeMax', value)}
                                />
                            </Form.Item>
                        </Col>
                        <Col xs={12} sm={6}>
                            <Form.Item label="Tipo">
                                <Select
                                    disabled
                                    style={{ width: '100%' }}
                                    value={custom.rangeDiscountType}
                                    onChange={(value) => this.updateCustomDiscount(index, 'rangeDiscountType', value)}
                                >
                                    <Option value="percentage">Porcentaje</Option>
                                    <Option value="fixed">Precio</Option>
                                </Select>
                            </Form.Item>
                        </Col>
                        <Col xs={12} sm={6}>
                            <Form.Item label="Descuento" style={{ marginBottom: 0 }}>
                                <InputNumber
                                    disabled={this.props.isLoading}
                                    min={0}
                                    style={{ width: '100%' }}
                                    formatter={(value) => {
                                        if (value === undefined || value === '') return ''
                                        return custom.rangeDiscountType === 'percentage' ? `${value}%` : `$ ${value}`
                                    }}
                                    parser={(value) => value.replace('%', '').replace('$', '').trim()}
                                    value={custom.rangeValue}
                                    onChange={(value) => this.updateCustomDiscount(index, 'rangeValue', value)}
                                />
                            </Form.Item>
                        </Col>
                    </Row>
                )}
            </Card>
        )
    }

    renderItemsQtys() {
        const { simplePercentage, customDiscounts } = this.state

        return (
            <Row>
                <Col xs={24} sm={24} md={24} lg={24} xl={{ span: 16, offset: 4 }}>
                    <div style={{ width: '100%' }}>
                        <Form onSubmit={this.handleSubmit}>
                            <Card
                                size="small"
                                style={{
                                    borderRadius: '8px',
                                    borderLeft: '4px solid #52c41a',
                                    boxShadow: '0 1px 4px rgba(0, 0, 0, 0.08)',
                                    textAlign: 'center',
                                }}
                                bodyStyle={{ padding: '24px' }}
                            >
                                <Title level={4} style={{ margin: 0, color: '#52c41a' }}>
                                    <Icon type="gift" style={{ marginRight: 8 }} />
                                    Descuento general
                                </Title>
                                <Paragraph type="secondary" style={{ marginTop: 4, marginBottom: 16 }}>
                                    Se aplica a todos los productos que no tengan un descuento personalizado o de rango.
                                </Paragraph>
                                <InputNumber
                                    disabled={this.props.isLoading}
                                    min={0}
                                    max={100}
                                    placeholder="Porcentaje de descuento"
                                    formatter={(value) => (value === undefined || value === '' ? '' : `${value}%`)}
                                    parser={(value) => value.replace('%', '')}
                                    style={{ width: '160px' }}
                                    size="large"
                                    onChange={(value) => this.updateAndNotify({ simplePercentage: value })}
                                    value={simplePercentage}
                                />
                            </Card>

                            <Divider orientation="left">Descuentos personalizados</Divider>

                            {customDiscounts.length === 0 && (
                                <Empty
                                    image={Empty.PRESENTED_IMAGE_SIMPLE}
                                    description="Aún no has agregado descuentos personalizados"
                                    style={{ marginBottom: '16px' }}
                                />
                            )}

                            {customDiscounts.map((custom, index) => this.renderCustomDiscount(custom, index))}

                            <Button
                                type="dashed"
                                onClick={this.addCustomDiscount}
                                block
                                style={{ marginTop: '16px', height: '44px' }}
                                disabled={this.props.isLoading}
                            >
                                <Icon type="plus" />
                                {' '}
                                Agregar descuento personalizado
                            </Button>

                            <Form.Item style={{ textAlign: 'center', marginTop: '32px' }}>
                                <Button
                                    type="primary"
                                    htmlType="submit"
                                    size="large"
                                    icon="save"
                                    disabled={this.props.isLoading}
                                    loading={this.props.isLoading}
                                    style={{ minWidth: '160px' }}
                                >
                                    Guardar
                                </Button>
                            </Form.Item>
                        </Form>
                    </div>
                </Col>
            </Row>
        )
    }

    renderItemBased = () => {
        const { form } = this.props
        const { getFieldDecorator } = form
        return (
            // eslint-disable-next-line react/jsx-fragments
            <React.Fragment>
                <Form.Item label="Tipo descuento" required>
                    {getFieldDecorator('discount_type', {
                        validateTrigger: ['onChange', 'onBlur'],
                        rules: [
                            {
                                required: true,
                                whitespace: true,
                                message: 'Es necesario seleccionar un tipo de descuendo.',
                            },
                        ],
                    })(
                        <Select style={{ width: '100%' }} disabled={this.props.isLoading}>
                            <Option value="percentage">Porcentaje</Option>
                            <Option value="fixed">Precio</Option>
                        </Select>,
                    )}
                </Form.Item>
                {/* eslint-disable-next-line prefer-template, quotes */}
                <Form.Item label={"Valor " + ((this.props.discount_type && this.props.discount_type.value === 'percentage') ? '%' : '$')} required>
                    {getFieldDecorator('discount_value', {
                        validateTrigger: ['onChange', 'onBlur'],
                        rules: [
                            {
                                required: true,
                                whitespace: true,
                                message: (this.props.discount_type && this.props.discount_type.value === 'percentage') ? 'Ingresa el porcentaje del descuento.' : 'Ingresa el precio del descuento.',
                            },
                        ],
                    })(<Input disabled={this.props.isLoading} placeholder={(this.props.discount_type && this.props.discount_type.value === 'percentage') ? '%' : '$'} style={{ width: '90%', marginRight: 8 }} />)}
                </Form.Item>
                <Button
                    type="primary"
                    htmlType="submit"
                    onClick={this.toComplete}
                    disabled={this.props.isLoading}
                    loading={this.props.isLoading}
                >
                    Siguiente
                </Button>
            </React.Fragment>
        );
    }

    render() {
        const { type, form } = this.props
        form.getFieldDecorator('keys', { initial_value: [] });
        form.getFieldDecorator('names', { initial_value: {} });
        return (
            // eslint-disable-next-line react/jsx-fragments
            <React.Fragment>
                {type && type.value === 'quantity_based' ? this.renderItemsQtys() : null}
                {type && type.value === 'item_based' ? this.renderItemBased() : null}
            </React.Fragment>
        );
    }
}

const DiscountsDiscountForm = Form.create({
    name: 'DiscountsRegistrationForm',
    onFieldsChange(props, changedFields) {
        props.onFieldChange(changedFields)
    },

    mapPropsToFields(props) {
        return {
            discount_value: Form.createFormField({
                ...props.discount_value,
            }),
            discount_type: Form.createFormField({
                ...props.discount_type,
            }),
        }
    },
})(DiscountForm)

export default DiscountsDiscountForm
